import { Heading } from "@digipost/dds-heading-react";
import { Infobox } from "@digipost/dds-infobox-react";
import { FC } from "react";

import BankId from "../infrastructure/assets/bankid.svg?react";
import Buypass from "../infrastructure/assets/buypass.svg?react";
import Translated from "../infrastructure/components/Translated";
import { useTranslate } from "../infrastructure/hooks/useTranslate";
import { LoginCard } from "./LoginCard";
import { LoginMethod, LoginRole } from "./LoginMethod";
import styles from "./Virksomhet.module.less";

const Virksomhet: FC = () => {
  const translate = useTranslate();

  const returnUrl = "/virksomhetsadmin/";
  return (
    <div className={styles.container}>
      <div className={styles.loginContent}>
        <Heading level={1} size={"large"}>
          <Translated textKey="virksomhet.header" />
        </Heading>

        <LoginCard
          title={"virksomhet.bankid_title"}
          description={"virksomhet.bankid_desc"}
          icon={<BankId />}
          returnUrl={returnUrl}
          loginRole={LoginRole.VIRKSOMHET}
          loginMethod={LoginMethod.BANK_ID}
        />
        <LoginCard
          title={"virksomhet.buypass_title"}
          description={"virksomhet.buypass_desc"}
          icon={<Buypass />}
          returnUrl={returnUrl}
          loginRole={LoginRole.VIRKSOMHET}
          loginMethod={LoginMethod.BUYPASS}
        />

        <div>
          <Infobox
            className={styles.infoBox}
            variant="info"
            title={translate("virksomhet.infobox_title")}
            level={3}
          >
            <Translated textKey={"virksomhet.infobox_content"} />
          </Infobox>
        </div>
      </div>
    </div>
  );
};

export default Virksomhet;
